import { ProductionGroupWellBase } from './base/production-group-well-base';

export class ProductionGroupWell extends ProductionGroupWellBase { }